export function addInstructorsGridControl() {
  const tutorContainer = document.querySelector('.tutors-full') as HTMLElement;
  const tutorsGrid = document.querySelector('.tutors-grid') as HTMLElement;
  const tutorElements = tutorsGrid?.querySelectorAll('.tutors-grid > div') as NodeListOf<HTMLElement>;
  const rectangle = document.querySelector('.course-overview .courses-slider-control .rectangle') as HTMLElement;
  const prevButton = document.querySelector('.previous_tutor') as HTMLButtonElement;
  const nextButton = document.querySelector('.next_tutor') as HTMLButtonElement;

  if (
    !tutorContainer
    || !tutorsGrid
    || !tutorElements.length
    || !rectangle
    || !prevButton
    || !nextButton
  ) {
    return; // Ensure all elements are available before proceeding
  }

  let visibleTutors = 3; // Number of tutors to show at a time for larger screens
  let currentIndex = 0; // Store the current index of the first visible tutor

  const totalItems = tutorElements.length;
  let totalSteps = Math.max(0, totalItems - visibleTutors);

  function updateTutorsVisibility() {
    if (window.innerWidth <= 988) {
      tutorElements.forEach((tutor) => {
        // eslint-disable-next-line no-param-reassign
        tutor.style.display = 'block';
      });
      tutorsGrid.style.overflowX = 'auto';
      tutorsGrid.style.scrollSnapType = 'x mandatory';
      tutorElements.forEach((tutor) => {
        // eslint-disable-next-line no-param-reassign
        tutor.style.scrollSnapAlign = 'start';
        // eslint-disable-next-line no-param-reassign
        tutor.style.flex = '0 0 50%"'; // Show two tutors at a time on smaller screens
      });
    } else {
      tutorsGrid.style.overflowX = 'hidden';
      tutorsGrid.style.scrollSnapType = 'none';
      tutorElements.forEach((tutor, index) => {
        // eslint-disable-next-line no-param-reassign
        tutor.style.scrollSnapAlign = 'none';
        // eslint-disable-next-line no-param-reassign
        tutor.style.flex = 'none';
        if (index >= currentIndex && index < currentIndex + visibleTutors) {
          // eslint-disable-next-line no-param-reassign
          tutor.style.display = 'block';
        } else {
          // eslint-disable-next-line no-param-reassign
          tutor.style.display = 'none';
        }
      });
    }
  }

  function updateRectangleWidth() {
    if (window.innerWidth <= 988) {
      const scrollPercentage = tutorsGrid.scrollLeft / (tutorsGrid.scrollWidth - tutorsGrid.clientWidth);
      rectangle.style.width = `${scrollPercentage * 100}%`;
    } else if (totalSteps === 0) {
      rectangle.style.width = '100%';
    } else {
      const progress = currentIndex / totalSteps;
      const minWidth = 1 / totalSteps;
      const maxWidth = 1 - minWidth;
      const width = minWidth + progress * maxWidth;
      rectangle.style.width = `${width * 100}%`;
    }
  }

  function updateButtonStates() {
    if (window.innerWidth <= 988) {
      prevButton.disabled = tutorsGrid.scrollLeft === 0;
      nextButton.disabled = tutorsGrid.scrollLeft >= tutorsGrid.scrollWidth - tutorsGrid.clientWidth;
    } else {
      prevButton.disabled = currentIndex === 0;
      nextButton.disabled = currentIndex >= totalItems - visibleTutors;
    }
    prevButton.classList.toggle('disabled', prevButton.disabled);
    nextButton.classList.toggle('disabled', nextButton.disabled);
  }

  function init() {
    updateTutorsVisibility();
    updateButtonStates();
    updateRectangleWidth();
  }

  init();

  nextButton.addEventListener('click', () => {
    if (window.innerWidth <= 988) {
      tutorsGrid.scrollBy({ left: tutorsGrid.clientWidth, behavior: 'smooth' });
    } else if (currentIndex < totalItems - visibleTutors) {
      currentIndex++;
      updateTutorsVisibility();
      updateButtonStates();
      updateRectangleWidth();
    }
  });

  prevButton.addEventListener('click', () => {
    if (window.innerWidth <= 988) {
      tutorsGrid.scrollBy({
        left: -tutorsGrid.clientWidth,
        behavior: 'smooth',
      });
    } else if (currentIndex > 0) {
      currentIndex--;
      updateTutorsVisibility();
      updateButtonStates();
      updateRectangleWidth();
    }
  });

  tutorsGrid.addEventListener('scroll', () => {
    if (window.innerWidth <= 988) {
      updateRectangleWidth();
      updateButtonStates();
    }
  });

  window.addEventListener('resize', () => {
    visibleTutors = window.innerWidth <= 988 ? 2 : 3;
    totalSteps = Math.max(0, totalItems - visibleTutors);
    currentIndex = 0;
    init();
  });
}
